import { Typography } from 'antd'
import { type TextProps as AntdTextProps } from 'antd/lib/typography/Text'
import styles from './styles.module.scss'

export interface TextProps extends AntdTextProps {
  noMargin?: boolean
  textAlign?: React.CSSProperties['textAlign']
}

export function Text({ noMargin, textAlign, ...props }: TextProps) {
  const classNames = noMargin ? [props.className, styles.noMargin] : [props.className]

  return <Typography.Text {...props} style={{ textAlign }} className={classNames.join(' ')} />
}
